import script from "./LandmarkMarker.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandmarkMarker.vue?vue&type=script&lang=ts&setup=true"

import "./LandmarkMarker.vue?vue&type=style&index=0&id=62a48c69&lang=css"

const __exports__ = script;

export default __exports__